import { render, staticRenderFns } from "./PackageItemsList.vue?vue&type=template&id=f4651a80&scoped=true&"
import script from "./PackageItemsList.vue?vue&type=script&lang=js&"
export * from "./PackageItemsList.vue?vue&type=script&lang=js&"
import style0 from "./PackageItemsList.vue?vue&type=style&index=0&id=f4651a80&lang=scss&scoped=true&"
import style1 from "./PackageItemsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4651a80",
  null
  
)

export default component.exports